import { ObjectId } from '@/utils/objectid'

export const deserialize = (value: string) => {
    return JSON.parse(value, (_key, v) => {
        if (v && typeof v === 'object') {
            if (typeof v.$date === 'string') {
                return new Date(v.$date)
            }
            if (typeof v.$oid === 'string') {
                return new ObjectId(v.$oid as string)
            }
        }
        return v
    })
}
